import React from "react";

import { Reorderable, isCategory, Authorization } from "types";
import { Item } from "./item";
import { Category } from "./category";

export const ListItem = ({
  listItem,
  authorization,
  is_template,
}: {
  listItem: Reorderable;
  authorization: Authorization;
  is_template: boolean;
}) => {
  return isCategory(listItem) ? (
    <Category category={listItem} authorization={authorization}></Category>
  ) : (
    <Item
      item={listItem}
      isTemplate={is_template}
      authorization={authorization}
    />
  );
};
